import { LegalDocumentPage } from './components/LegalDocumentPage';
import { PRIVACY_POLICY } from './legal-content';

/** Privacy Policy route (PP-029 / proweb-102 AC-001). */
export function PrivacyPolicyPage(): React.JSX.Element {
  return <LegalDocumentPage document={PRIVACY_POLICY} />;
}
